import React from "react";
import "./terms-conditions.css";

const PrivacyPolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Privacy Policy</h1>
      </header>

      <section className="tc-content mb-3">
        <p>
          We, at Singh Finlease Private Limited (“Loanonsalary” or “We”), value your privacy and are committed 
          to protecting your personal data. This Privacy Policy explains how we collect, use, store, and 
          disclose your information when you access our website www.loanonsalary.com (the “Website”). 
          By using our Website, you agree to the practices described in this policy.
        </p>
        <p>
          This Privacy Policy is prepared in compliance with:
          <br />
          a. Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011. 
          <br />
          b. Guidelines on Digital Lending issued by the Reserve Bank of India (RBI), 2022. 
          <br />
          c. Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021.
        </p>

        <h2>1. CONSENT</h2>
        <p>
          You hereby expressly consent to provide the information required to avail of the lending services 
          facilitated by Loanonsalary (Singh Finlease Private Limited). You acknowledge that we shall collect 
          this information to verify your identity and assess your creditworthiness. 
          <b> IF YOU DO NOT AGREE TO THIS POLICY, PLEASE DO NOT ACCESS OR USE THE WEBSITE.</b>
        </p>

        <h2>2. COLLECTION OF INFORMATION</h2>
        <p>
          In accordance with RBI’s Digital Lending Guidelines, we follow a strict data minimization policy. 
          We only collect information necessary to facilitate your loan application.
        </p>

        <ol style={{ paddingLeft: "20px", color: "#000", lineHeight: "1.6" }}>
          <li>
            <span style={{ color: "#052daa", textDecoration: "underline", marginRight: "8px" }}>
              <b>Personal Information:</b>
            </span>
            This includes your full name, email ID, PAN, Aadhaar details (for KYC purposes), address, 
            mobile number, and employment details.
          </li>

          <li>
            <span style={{ color: "#052daa", textDecoration: "underline", marginRight: "8px" }}>
              <b>Financial Data:</b>
            </span>
            We collect your bank account details, bank statements, and salary information to process 
            the loan disbursement and manage repayments.
          </li>

          <li>
            <span style={{ color: "#052daa", textDecoration: "underline", marginRight: "8px" }}>
              <b>Transactional SMS:</b>
            </span>
            We do not read personal SMS. We only monitor transactional SMS (sent by 6-digit alphanumeric senders) 
            to understand your financial behavior and verify your income for credit assessment.
          </li>

          <li>
            <span style={{ color: "#052daa", textDecoration: "underline", marginRight: "8px" }}>
              <b>One-Time Access:</b>
            </span>
            We may require one-time access to your camera and microphone solely for the purpose of 
            performing Video KYC as per regulatory requirements. We do not access your gallery, 
            contacts, or call logs.
          </li>
        </ol>

        <h2>3. PURPOSE OF COLLECTION</h2>
        <p>The data collected on the Website is used to:</p>
        <ul>
          <li>Establish and verify your identity through KYC.</li>
          <li>Facilitate loan underwriting and credit scoring.</li>
          <li>Comply with RBI regulations, anti-money laundering (AML) laws, and other statutory requirements.</li>
          <li>Communicate loan status, repayment reminders, and promotional offers.</li>
          <li>Prevent fraud and ensure the security of our financial platform.</li>
        </ul>

        <h2>4. DATA STORAGE AND SECURITY</h2>
        <p>
          As per RBI mandates, all data collected from you is stored on secure servers located within 
          the territory of India. We use 128-bit SSL encryption for data transmission and implement 
          strict access controls to prevent unauthorized data breaches.
        </p>

        <h2>5. DISCLOSURE TO THIRD PARTIES</h2>
        <p>
          We share your information with third parties only on a "need-to-know" basis, including:
          <br />
          a. Credit Information Companies (Bureaus) as per statutory requirements.
          <br />
          b. Statutory or judicial authorities to comply with legal obligations.
          <br />
          c. Technology partners who assist in KYC verification and loan processing under strict confidentiality agreements.
        </p>

        <h2>6. YOUR RIGHTS: RETENTION AND DELETION</h2>
        <p>
          You have the right to access, rectify, and update your personal information. You also have 
          the right to withdraw your consent for data processing or request the deletion of your account. 
          Please note that we may retain certain information if required by law or if you have an active 
          outstanding loan with Singh Finlease Private Limited.
        </p>

        <h2>7. GRIEVANCE REDRESSAL MECHANISM</h2>
        
        <h4>Grievance Redressal Officer</h4>
        <div style={{ border: "1px solid #ddd", padding: "15px", borderRadius: "5px", marginBottom: "15px" }}>
          <p>
            <b>Name:</b> Mr. Jitender Kumar <br />
            <b>Company:</b> Singh Finlease Private Limited (Loanonsalary) <br />
            <b>Address:</b> A-29, Mangolpuri Industrial Area, Phase - II, Delhi, 110034 <br />
            <b>Contact:</b> 9910739751 <br />
            <b>Email:</b> grievance@loanonsalary.com
          </p>
        </div>

        <h4>Nodal Officer</h4>
        <div style={{ border: "1px solid #ddd", padding: "15px", borderRadius: "5px" }}>
          <p>
            <b>Name:</b> Mr. Gaurav <br />
            <b>Company:</b> Singh Finlease Private Limited (Loanonsalary) <br />
            <b>Address:</b> A-29, Mangolpuri Industrial Area, Phase - II, Delhi, 110034 <br />
            <b>Contact:</b> 9643383686 <br />
            <b>Email:</b> nodal@loanonsalary.com
          </p>
        </div>

        <p style={{ marginTop: "15px" }}>
          In case the Borrower does not receive a response from the Grievance Redressal Official or the Nodal Officer 
          within 1 (one) month, a complaint may be made in accordance with the 'Reserve Bank-Integrated Ombudsman Scheme, 2021'.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;